module.exports = __webpack_public_path__ + "static/media/Realhousey1.70e97d26.mp4";